import { createResourceLibrary } from "active-resource";

const tokenDom = document.querySelector("meta[name=csrf-token]");
const csrfToken = tokenDom ? tokenDom.content : null;

export default createResourceLibrary("/api/", {
  headers: { "X-CSRF-Token": csrfToken },
});
